import { createAction } from "redux-actions";
import { createAsyncAction } from "../helpers";

export const getSeasonalUniquePlayersAsyncAction = createAsyncAction(
	"GET_SEASONAL_UNIQUE_PLAYERS_REQUEST",
	"GET_SEASONAL_UNIQUE_PLAYERS_SUCCESS",
	"GET_SEASONAL_UNIQUE_PLAYERS_FAILURE",
	"GET_SEASONAL_UNIQUE_PLAYERS_CANCEL"
);

export const getDashboardAsyncAction = createAsyncAction("GET_DASHBOARD");

export const changeUserChartAction = createAsyncAction("CHANGE_USER_CHART");

export const changeOnlineTourAction = createAsyncAction("CHANGE_ONLINE_TOUR");

export const changeOfflineTourAction = createAsyncAction("CHANGE_OFFLINE_TOUR");

export const resetAction = createAction("DASHBOARD_RESET_ACTIONS");
